(() => {
  const SELECTOR = 'a[data-ppc-lightbox]';
  const body = document.body;

  // ----------------------------
  // Build lightbox (once)
  // ----------------------------
  const lightbox = document.createElement('div');
  lightbox.className = 'ppc-lightbox';
  lightbox.innerHTML = `
    <div class="ppc-lightbox__backdrop" data-ppc-close></div>
    <div class="ppc-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Image preview">
      <div class="ppc-lightbox__frame">
        <button class="ppc-lightbox__nav ppc-lightbox__nav--prev" type="button" aria-label="Previous image">‹</button>
        <img class="ppc-lightbox__img" alt="">
        <button class="ppc-lightbox__nav ppc-lightbox__nav--next" type="button" aria-label="Next image">›</button>
        <button class="ppc-lightbox__close" type="button" aria-label="Close">×</button>
      </div>
    </div>
  `;
  body.appendChild(lightbox);

  const imgEl = lightbox.querySelector('.ppc-lightbox__img');
  const btnClose = lightbox.querySelector('.ppc-lightbox__close');
  const btnPrev = lightbox.querySelector('.ppc-lightbox__nav--prev');
  const btnNext = lightbox.querySelector('.ppc-lightbox__nav--next');

  let activeGroup = [];
  let activeIndex = 0;
  let lastFocusedEl = null;

  // ----------------------------
  // Helpers
  // ----------------------------
  function getGroupLinks(clickedLink) {
    const groupName = clickedLink.getAttribute('data-ppc-lightbox') || 'default';

    // Avoid brittle querySelector attribute escaping by filtering in JS
    const all = Array.from(document.querySelectorAll(SELECTOR));
    const group = all.filter((a) => (a.getAttribute('data-ppc-lightbox') || 'default') === groupName);

    return group.length ? group : [clickedLink];
  }

function setNavVisibility() {
  const show = activeGroup.length > 1;

  btnPrev.classList.toggle('is-visible', show);
  btnNext.classList.toggle('is-visible', show);

  // Belt + suspenders: inline style beats weird theme CSS
  btnPrev.style.display = show ? '' : 'none';
  btnNext.style.display = show ? '' : 'none';
}

  function showImageByIndex(i) {
    if (!activeGroup.length) return;

    activeIndex = (i + activeGroup.length) % activeGroup.length;
    const link = activeGroup[activeIndex];

    const href = link.getAttribute('href');
    if (!href) return;

    const alt =
      link.querySelector('img')?.getAttribute('alt') ||
      link.getAttribute('aria-label') ||
      'Image preview';

    // Hide UI until image is ready (pairs with .ppc-lightbox.is-ready CSS)
    lightbox.classList.remove('is-ready');

    // Set handlers BEFORE setting src
    imgEl.onload = () => {
      lightbox.classList.add('is-ready');
    };
    imgEl.onerror = () => {
      lightbox.classList.add('is-ready');
    };

    imgEl.alt = alt;
    imgEl.src = href;
  }

  function openLightbox(linkEl) {
    lastFocusedEl = document.activeElement;

    activeGroup = getGroupLinks(linkEl);
    activeIndex = Math.max(0, activeGroup.indexOf(linkEl));

    setNavVisibility();

    lightbox.classList.add('is-open');
    body.classList.add('ppc-lightbox-open');

    showImageByIndex(activeIndex);

    // Focus close for accessibility
    btnClose.focus();
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightbox.classList.remove('is-ready');
    body.classList.remove('ppc-lightbox-open');

    // Stop network churn on close/reopen
    imgEl.src = '';
    imgEl.alt = '';

    if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') {
      lastFocusedEl.focus();
    }
  }

  // ----------------------------
  // Click handlers
  // ----------------------------
  document.addEventListener('click', (e) => {
    const link = e.target.closest(SELECTOR);
    if (link) {
      e.preventDefault();
      openLightbox(link);
      return;
    }

    // close via backdrop click
    if (e.target.matches('[data-ppc-close]')) {
      closeLightbox();
    }
  });

  btnClose.addEventListener('click', closeLightbox);
  btnPrev.addEventListener('click', () => showImageByIndex(activeIndex - 1));
  btnNext.addEventListener('click', () => showImageByIndex(activeIndex + 1));

  // Optional: click image closes too (nice UX)
  imgEl.addEventListener('click', closeLightbox);

  // ----------------------------
  // Keyboard
  // ----------------------------
  document.addEventListener('keydown', (e) => {
    if (!lightbox.classList.contains('is-open')) return;

    if (e.key === 'Escape') {
      closeLightbox();
      return;
    }

    if (activeGroup.length > 1) {
      if (e.key === 'ArrowLeft') showImageByIndex(activeIndex - 1);
      if (e.key === 'ArrowRight') showImageByIndex(activeIndex + 1);
    }
  });
})();